import { styled } from '@linaria/react'
import React, { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Boxes } from '../components/Boxes'
import { useAppContext } from '../contexts/App.context'
import { WalletConnectionRequiredDialog } from '../dialogs/WalletConnectionRequiredDialog'
import { colors } from '../styles/colors'
import { ButtonRegular } from '../ui/Button'
import { Loader } from '../ui/Loader'
import { Tabs } from '../ui/Tabs'
import { Typography } from '../ui/Typography'
import { formatTon } from '../utils/formatTon'

export const ProfilePage: FC<{ activeTab: ProfileBoxTypeTab }> = ({
  activeTab,
}) => {
  const { formatMessage } = useIntl()
  const { wallet, userProfile, isLoadingProfile } = useAppContext()

  if (!wallet) {
    return <WalletRequired />
  }

  return (
    <Container>
      <ButtonsContainer>
        <ButtonStyled
          backgroundColor={colors.secondaryLight}
          fontSize={16}
          textWeight={700}
          textColor={colors.secondary}
          isWithTypographyWrapper={false}
        >
          <Typography fontSize={16} fontWeight={700} color={colors.secondary}>
            {isLoadingProfile ? (
              <SmallLoader />
            ) : (
              formatTon((userProfile?.unclaimedVoteCount || 0).toString())
            )}
          </Typography>

          <Typography fontSize={10} fontWeight={400} color={colors.grey800}>
            <FormattedMessage
              id="profile.unclaimedVoteCount"
              defaultMessage="Не забранные победившие голоса"
            />
          </Typography>
        </ButtonStyled>

        <ButtonStyled
          backgroundColor={colors.secondaryLight}
          isWithTypographyWrapper={false}
        >
          <Typography fontSize={16} fontWeight={700} color={colors.secondary}>
            {isLoadingProfile ? (
              <SmallLoader />
            ) : (
              formatTon((userProfile?.tvl || 0).toString())
            )}
          </Typography>

          <Typography fontSize={10} fontWeight={400} color={colors.grey800}>
            <FormattedMessage
              id="profile.tvl"
              defaultMessage="Заблокировано TON в активных боксах"
            />
          </Typography>
        </ButtonStyled>
      </ButtonsContainer>

      <Boxes
        status="all"
        titleElement={null}
        votedByMe={activeTab === ProfileBoxTypeTab.Votes}
        createdByMe={activeTab === ProfileBoxTypeTab.MyBoxes}
        tabsElement={
          <Tabs
            tabs={[
              {
                to: profileVotesPagePath,
                id: ProfileBoxTypeTab.Votes,
                label: formatMessage({
                  id: 'tab-votes',
                  defaultMessage: 'Голоса',
                }),
              },
              {
                to: profileMyBoxesPagePath,
                id: ProfileBoxTypeTab.MyBoxes,
                label: formatMessage({
                  id: 'tab-my-boxes',
                  defaultMessage: 'Мои боксы',
                }),
              },
            ]}
            activeTabId={activeTab}
          />
        }
      />
    </Container>
  )
}

export enum ProfileBoxTypeTab {
  Votes = 'votes',
  MyBoxes = 'my-boxes',
}

export const profileVotesPagePath = `/profile/${ProfileBoxTypeTab.Votes}`
export const profileMyBoxesPagePath = `/profile/${ProfileBoxTypeTab.MyBoxes}`

const Container = styled.div`
  display: grid;
  width: 100%;
  gap: 12px;
  align-content: flex-start;
`

const ButtonsContainer = styled.div`
  display: grid;
  align-content: flex-start;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
`

const ButtonStyled = styled(ButtonRegular)`
  display: grid;
  justify-content: flex-start;
  text-align: left;
  padding: 8px 16px;
  border-radius: 16px;
`

const WalletRequired = styled(WalletConnectionRequiredDialog)`
  align-self: center;
`

const SmallLoader = styled(Loader)`
  height: 16px;
  width: 16px;
`
